import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0e626b07")

_pushScopeId("data-v-0e626b07")
const _hoisted_1 = { open: "" }
const _hoisted_2 = { class: "patient-info-details" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _createVNode("details", _hoisted_1, [
        _createVNode("summary", null, _toDisplayString(`患者情報 ${_ctx.patientInfo}`), 1),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", null, _toDisplayString(_ctx.phoneNumber), 1),
          _createVNode("div", null, "初回：" + _toDisplayString(_ctx.firstDateString), 1),
          _createVNode("div", null, "最終：" + _toDisplayString(_ctx.lastDateString), 1)
        ])
      ])
    ]),
    _: 1
  }))
})